import React from 'react'
import '../styles/loading.css'
const Loading = () => {
  return (
    <>
    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div> 
    <div>Loading</div>
</>
 )
}

export default Loading